import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type DeleteVoucherAutoAssignmentRuleResponse, deleteVoucherAutoAssignmentRule } from '~/services/PromoService';

import { voucherAutoAssignmentRuleQueryKeys } from './voucherAutoAssignmentRuleQueryKeys';

export function useDeleteVoucherAutoAssignmentRule() {
  const queryClient = useQueryClient();
  return useMutation<DeleteVoucherAutoAssignmentRuleResponse, Error, string>({
    mutationFn: (voucherAutoAssignmentRuleId) => deleteVoucherAutoAssignmentRule(voucherAutoAssignmentRuleId),
    onSuccess: (_data, voucherAutoAssignmentRuleId) => {
      queryClient.invalidateQueries({ queryKey: voucherAutoAssignmentRuleQueryKeys.all });
      queryClient.removeQueries({ queryKey: voucherAutoAssignmentRuleQueryKeys.detail(voucherAutoAssignmentRuleId) });
    },
  });
}
